import type { NavigationItemType } from "../../root/layout/SidebarMenuItem";
import type { Paths } from "../../shared/usePrivacyNavigate";
import { dashboardQueryOptions } from "../../api/dashboard";
import { prefetch } from "../../api/prefetch";
import { DashboardPage } from "./DashboardPage";

export const route: NavigationItemType["route"] = {
  path: "dashboard",
  element: <DashboardPage />,
  loader: () => void prefetch(dashboardQueryOptions()),
};
export const to = (paths: Paths) => paths.dashboard();
